import { connect } from 'react-redux'

import FormStatus from './component'

const mapStateToProps = (state) => ({
  contactEmail: state.config.CONTACT_EMAIL,
})

export default connect(mapStateToProps)(FormStatus)
